import script from './component-lib.esm4.js';
import normalizeComponent from '../../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isExpand ? _c('BtnExpand', {
    ref: "expand",
    attrs: {
      "isOpen": _vm.isOpen
    },
    on: {
      "close": function ($event) {
        _vm.isOpen = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (ref) {
        var attrs = ref.attrs;
        return [_c('ProfileBtn', _vm._b({
          staticClass: "v-profile-btn",
          attrs: {
            "component": "button",
            "label": _vm.formOptions.button_text
          },
          on: {
            "click": _vm.handleClick
          }
        }, 'ProfileBtn', Object.assign({}, attrs, _vm.btnProps), false), [_c('ChevronIcon', {
          attrs: {
            "slot": "icon-right"
          },
          slot: "icon-right"
        })], 1)];
      }
    }], null, false, 1061694783)
  }, [_vm._v(" "), _c('iframe', {
    ref: "iframe",
    staticClass: "frame",
    staticStyle: {
      "min-width": "100%",
      "height": "539px",
      "border": "none"
    },
    attrs: {
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": _vm.url,
      "frameborder": "0",
      "scrolling": "no"
    }
  })]) : _c('div', {
    staticClass: "jotform-container"
  }, [_c('iframe', {
    ref: "iframe",
    staticClass: "frame",
    staticStyle: {
      "min-width": "100%",
      "height": "539px",
      "border": "none"
    },
    attrs: {
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": _vm.url,
      "frameborder": "0",
      "scrolling": "no"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-1fa18749_0", {
    source: ".jotform-container[data-v-1fa18749]{background:var(--c-bg-color);border:var(--p-btn-border-width) solid var(--p-btn-border-color);border-width:min(var(--p-btn-border-width),5px);border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);overflow:hidden;width:100%}.frame[data-v-1fa18749]{border-radius:min(var(--p-btn-border-radius),10px);display:block;margin:0}",
    map: undefined,
    media: undefined
  }), inject("data-v-1fa18749_1", {
    source: ".v-form--remove-bg .jotform-container{background:0 0;border:none;border-radius:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-1fa18749";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Jotform = __vue_component__;
export { Jotform as default };